import React from 'react';
import { Link } from 'react-router-dom';
import '@justinribeiro/lite-youtube';
import { v4 as uuidv4 } from 'uuid';


function Video(Video) {
  return (
    <div className='video'>
      <lite-youtube class="video__iframe" videoid={Video.url.substring(30,41)} videoplay="Voir" videotitle={Video.title} posterquality="maxresdefault" autopause>
        <a href={Video.url}>Voir sur YouTube: {Video.title}</a>
      </lite-youtube>
      <div className='video__description-container'>
        <div className='video__categories-container'>
          {Video.category.map((cat) => (
            cat.visible && <span className='video__categories' key={uuidv4()}>#{cat.name}</span>
          ))}
        </div>
        <h2 className="video__title">{Video.title}</h2>
        <p className="video__desc">{Video.desc}</p>
        <Link className="video__button" to={`/video/${Video.title.replace(/\?|\s+/g, '-')}/${Video.id}`} state={{video: Video}} tabIndex="0" target="_blank">Voir plus</Link>
      </div>
    </div>
  );
} 

function VideoContainer({ListVideo}) {
  return (
    <div className='videoContainer'>
      {/* Ignore chain optional condition */}
      {ListVideo && ListVideo?.map((video) => (
        <Video
          key={uuidv4()}
          id={video.id}
          title={video.title}
          url={video.url}
          desc={video.desc}
          category={video.category}
        />
      ))}
    </div>
  );
}

export default VideoContainer;